	<form [formGroup]="formGroup" (ngSubmit)="submit()" autocomplete="off" >
    <div class="pfm-cat-icon-wrapper">
        <div class="pfm-cat-icon">
          <ng-container *ngIf="pfmCategoryDetailsFormHelper.pfmMainService.selectedpfmCategoryData?.icon; else noPhoto">
            <img  [src]="'./assets/images/'+pfmCategoryDetailsFormHelper.pfmMainService.selectedpfmCategoryData?.icon+'.svg'" />
            </ng-container>
          <ng-template #noPhoto>
            <img  [src]="'./assets/images/icons/default-profile-pic.svg'">
          </ng-template>
        </div>
    </div>
	 <div class="entry-form">
    <div class="pfm-category-details">
      <span class="pfm-category-title">{{pfmCategoryDetailsFormHelper.pfmMainService.selectedpfmCategoryData?.description}}
        <span class="pfm-category-month"> ( {{state.currentPfmSpendDate}} )</span>
      </span>
      <span class="pfm-amount">
        <span class="pfm-tranTotal">{{commonService.formatAmount(pfmCategoryDetailsFormHelper.pfmMainService.selectedpfmCategoryData?.tranTotal)}}</span>
        <span class="pfm-currency"> {{commonService.baseCurrency}}</span>
        </span>
    </div>
    <div class="tab-container">
        <div class="mat-content" (touchstart)="pfmCategoryDetailsFormHelper.swipe($event, 'start')"
        (touchend)="pfmCategoryDetailsFormHelper.swipe($event, 'end')">
      <mat-tab-group  [(selectedIndex)]="state.selectedTab" (selectedTabChange)="pfmCategoryDetailsFormHelper.tabChanged($event)">
        <mat-tab label="History">
          <div class="main-grid-container">
            <app-pfm-category-history-display-grid ></app-pfm-category-history-display-grid>

            <div class="not-found" [ngStyle]="{'display': (state.isCategoryHistoryEmpty) ? 'block' : 'none' }">
              <div class="not-found-image-notif">
                <img class="noti-img" src="./assets/images/empty-transactions.svg" id="leftImg" alt="image1" />
              </div>
              <div class="no-notifi-text-empty">No data available</div>
        
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Insights">
          <div class="grid-container">
            <app-pfm-category-insights-form  [ngStyle]="{'display': (!state.isInsightChartEmpty) ? 'block' : 'none' }"></app-pfm-category-insights-form>

            <div class="not-found" [ngStyle]="{'display': (state.isInsightChartEmpty) ? 'block' : 'none' }">
              <div class="not-found-image-notif">
                <img class="noti-img" src="./assets/images/empty-transactions.svg" id="leftImg" alt="image1" />
              </div>
              <div class="no-notifi-text-empty">No data available</div>
        
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
      </div>
    </div>
	 </div>
	</form>

